import pickBy from 'lodash/pickBy'
import { isEmpty } from 'ramda'

const getUrlParamsAndSetState = setState => {
  var sURL = window.document.URL.toString()
  var arrParams = sURL.split('?')
  if (arrParams.length > 1) {
    var arrURLParams = arrParams[1].split('&')
    var i = 0
    const extractedParams = {}
    for (i = 0; i < arrURLParams.length; i++) {
      var sParam = arrURLParams[i].split('=')
      extractedParams[sParam[0]] = sParam[1]
    }
    setState(extractedParams)
  }
}

export const setUrlParams = queryObject => {
  const queryParams = new URLSearchParams()

  // ignore empty values
  const filteredParams = pickBy(queryObject, value => {
    return !isEmpty(value) || !!value
  })

  for (const key in queryObject) {
    // ignore empty lists
    if (
      filteredParams.hasOwnProperty(key) &&
      queryObject[key]?.toString()?.length > 0
    ) {
      queryParams.append(key, queryObject[key])
    }
  }

  return queryParams?.toString()
}

export const getUrlParams = () => {
  const urlSearchParams = new URLSearchParams(window.location.search)
  return Object.fromEntries(urlSearchParams.entries())
}

export default getUrlParamsAndSetState
